/* eslint-disable react/jsx-props-no-spreading */
import ReactSwitch from 'react-switch';

export interface SwitchProps {
    size?: 'sm' | 'md' | 'lg';
    onChange: (checked: boolean, event: MouseEvent | React.SyntheticEvent<MouseEvent | KeyboardEvent>, id: string) => void;
    checked: boolean;
    offLabel?: string;
    onLabel?: string;
    disabled?: boolean;
    id?: string;
}

const switchSizes = {
    sm: {
        height: 24,
        width: 40,
        handleDiameter: 16,
    },
    md: {
        height: 32,
        width: 56,
        handleDiameter: 24,
    },
    lg: {
        height: 40,
        width: 64,
        handleDiameter: 32,
    },
};

const switchStyle = {
    onColor: '#4716ED',
    offColor: '#4716ED',
    onHandleColor: '#FFFFFF',
    offHandleColor: '#FFFFFF',
    activeBoxShadow: '0px 0px 1px 4px rgba(0, 0, 0, 0.2)',
    uncheckedIcon: false,
    checkedIcon: false,
};

const Switch = ({
    size = 'md',
    disabled,
    onChange,
    checked,
    offLabel,
    onLabel,
    id,
}: SwitchProps): JSX.Element => {
    const switchSize = switchSizes[size];

    return (
        <div className="switch">
            {offLabel && (
                <span className={`switch-label switch-off-label ${checked ? 'checked' : ''}`}>{offLabel}</span>
            )}
            <label
                className="switch-checkbox-label"
                htmlFor={id}
            >
                <ReactSwitch
                    onChange={onChange}
                    checked={checked}
                    disabled={disabled}
                    id={id}
                    {...switchStyle}
                    {...switchSize}
                />
            </label>
            {onLabel && (
                <span className={`switch-label switch-on-label ${checked ? 'checked' : ''}`}>{onLabel}</span>
            )}
        </div>
    );
};

export default Switch;
